import { Colors, Text, Typography } from '@zapier/design-system';
import { css } from '@emotion/react';

import { mediaQueries } from '@zapier/identity-utils';
import { FeatureItem, FeatureItemList } from '../FeatureItem';

const rootStyles = css`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

const headerStyles = css`
  ${Typography.sectionHeader1Extrabold}
  ${Typography.pageHeader7}
  color: ${Colors.neutral800};
  margin-bottom: 30px;
  text-align: center;

  ${mediaQueries.tablet} {
    text-align: left;
  }

  ${mediaQueries.desktop} {
    ${Typography.pageHeader5}
  }
`;

export function HashbrownTrialPromo() {
  return (
    <div css={rootStyles}>
      <div css={headerStyles}>Make the switch to Zapier</div>
      <Text type="paragraph1" margin="0 0 25px 0">
        Zapier empowers you to automate your work across 4,000 apps-like Slack,
        Gmail, and Mailchimp-so you can move forward, faster.
      </Text>
      <FeatureItemList>
        <FeatureItem>Easy setup, no coding required</FeatureItem>
        <FeatureItem>Free forever for core features</FeatureItem>
        <FeatureItem>14-day trial of premium features &amp; apps</FeatureItem>
      </FeatureItemList>
    </div>
  );
}
